import { PeopleSlider } from '../people/view-script.js';

class PeopleTabs {
	constructor( node, config ) {
		this.node     = node;
		// this.heading  = new FittedText( node.querySelector( '.people-tabs__heading' ) );
		this.links    = this.node.querySelectorAll( '.people-tabs__nav-link--tab' );
		this.back     = this.node.querySelector( '.people-tabs__nav-link--back' );
		this.forward  = this.node.querySelector( '.people-tabs__nav-link--forward' );
		this.contents = this.node.querySelectorAll( '.people-tabs__content > .people' );
		this.sliders  = Array.from( this.contents ).map( content => new PeopleSlider( content ) );
		this.index    = -1;

		this.back.addEventListener( 'click', () => {
			if ( this.sliders[ this.index ] ) {
				this.sliders[ this.index ].backIndex();
			}
		} );

		this.forward.addEventListener( 'click', () => {
			if ( this.sliders[ this.index ] ) {
				this.sliders[ this.index ].forwardIndex();
			}
		} );

		this.sliders.forEach( ( slider, index ) => {
			slider.content.addEventListener( 'scroll', () => {

				if ( index === this.index ) {
					this.setState();
				}
			} );
		} );

		this.activate( 0 );
		this.links.forEach( ( link, index ) => link.addEventListener( 'click', () => this.activate( index ) ) );
	}

	setState() {
		if ( this.sliders[ this.index ] ) {
			this.sliders[ this.index ].setState();

			if ( this.sliders[ this.index ].back.disabled ) {
				this.back.disabled = true;
			} else {
				this.back.removeAttribute( 'disabled' );
			}

			if ( this.sliders[ this.index ].forward.disabled ) {
				this.forward.disabled = true;
			} else {
				this.forward.removeAttribute( 'disabled' );
			}
		}
	}

	activate( index ) {
		if ( this.index > -1 ) {
			if ( this.links[ this.index ] ) {
				this.links[ this.index ].classList.remove( 'people-tabs__nav-link--active' );
			}

			if ( this.contents[ this.index ] ) {
				this.contents[ this.index ].classList.remove( 'people--active' );
			}
		}

		this.index = index;

		if ( this.index > -1 ) {
			if ( this.links[ this.index ] ) {
				this.links[ this.index ].classList.add( 'people-tabs__nav-link--active' );
			}

			if ( this.contents[ this.index ] ) {
				this.contents[ this.index ].classList.add( 'people--active' );
			}
		}

		this.setState();
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	for ( const node of document.querySelectorAll( '.people-tabs' ) ) {
		new PeopleTabs( node );
	}
} );
